import script from "./Payroll-Configuration-Questionnaire-Main.vue?vue&type=script&setup=true&lang=js"
export * from "./Payroll-Configuration-Questionnaire-Main.vue?vue&type=script&setup=true&lang=js"

import "./Payroll-Configuration-Questionnaire-Main.vue?vue&type=style&index=0&id=8f029700&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f029700"]])

export default __exports__